// A meeting's prep page, read through Breeze's own API (the operator's only).
// `usePrepNow` finds the meeting on now for a call the operator hosts, so the
// call menu can offer Prep only when there is one.

import { useEffect, useState } from "react";
import type { PrepData } from "@breeze/core";
import { api } from "../lib/api";

export interface PrepState {
  readonly data: PrepData | null;
  readonly loading: boolean;
}

function usePrepFrom(path: string | null): PrepState {
  const [state, setState] = useState<PrepState>({ data: null, loading: path !== null });
  useEffect(() => {
    if (path === null) {
      setState({ data: null, loading: false });
      return;
    }
    const controller = new AbortController();
    setState((s) => ({ data: s.data, loading: true }));
    api<PrepData>(path, { signal: controller.signal })
      .then((data) => setState({ data, loading: false }))
      .catch((err: unknown) => {
        if ((err as Error).name === "AbortError") return;
        setState({ data: null, loading: false });
      });
    return () => controller.abort();
  }, [path]);
  return state;
}

/** The meeting on now. `names` are the guests in the room, which narrow it
 * when two meetings overlap. Off when `enabled` is false. */
export function usePrepNow(enabled: boolean, names: string): PrepState {
  return usePrepFrom(enabled ? `/api/prep?now=1${names ? `&names=${encodeURIComponent(names)}` : ""}` : null);
}
